import React from 'react'

const reportSettings = () => {
  return (
    <div>reportSettings</div>
  )
}

export default reportSettings